import { PHOSPHOR_ICON_NAMES } from './phosphor';

const duotoneIcons = {
  description: 'Phosphor Duotone Icons',
  // Tab button thumbnail — the "Shapes" icon represents a collection of icons
  image: { icon: 'Shapes' },
  getList: () => Promise.resolve(PHOSPHOR_ICON_NAMES.map(name => ({ icon: name }))),
};

export default duotoneIcons;
